const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'treesManagement',
		'trees'
	],

	methods: {
		sanitizeResources(){
			var self = this;
			var resources = {
				initialized: false,
				trees: [
					{
						name: 'MailingLists ...',
						tree: [],
						nodes: {}
					}
				]
			};
			var tree = resources.trees[0].tree;
			var nodes = resources.trees[0].nodes;
			var id;

			if(this.resourceData.data && !this.resourceData.initialized) {
				this.resetNodeMappings();
				self.config.extendedTreeView = this.hasRoleOption('extendedTreeView');

				utils.forEach(this.resourceData.data, function (mailinglistData) {
					resources.initialized = true;
					if(mailinglistData.attributes) {
						var mailinglist = mailinglistData.attributes;
						var primaryKey = mailinglist[mailinglistData.primaryKey || 'id'];
						var parent = '#';

						mailinglist.index = self.transformIDToIndex(primaryKey, 'mailinglist', 0, tree.length);

						// estimate right text for this leaf
						var text = mailinglist.name;

						tree.push({
							id: mailinglist.index,
							parent: parent,
							text: text + (self.config.isComponentUsageAdmin ? ' [' + primaryKey + ']' : ''),
							type: 'mailinglist',
							state: {
								opened: true,
								disabled: false,
								selected: false
							},
							li_attr: {},
							a_attr: {}
						});
						nodes[mailinglist.index] = mailinglist;
					}
				});

				this.resourceData.trees = resources.trees;
				this.resourceData.initialized = resources.initialized;
			}
		},

		// operations
		showInsert: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			if(this.actions[baseActionKey]){
				this.deselectActiveNode();
				return this.performAndStoreAction(baseActionKey);
			}

			return utils.promise.reject();
		},

		showDuplicate: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			var nodeData    = this.getSelectedNodeData();

			if(this.actions[baseActionKey] && nodeData.id){

				return this.performAction(
					this.prepareAction(baseActionKey, nodeData.id)
				);
			}

			return utils.promise.reject();
		},

		delete: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			var self = this;

			return self.performDecision(
				'confirm',
				{
					component:  self,
					title:      storage.__('hint.delete.really.' + buttonContext + '.title'),
					message:    storage.__('hint.delete.really.' + buttonContext + '.message')
				}
			).then(function(context) {
				if (context.decision.type === 'yes') {
					var nodeID = self.getSelectedNodeID();
					var nodeIndex = self.getSelectedNodeIndex();
					if(self.actions[baseActionKey] && !utils.isEmpty(nodeID)){
						self.setClosestNodeAsReady(nodeIndex);
						self.deselectActiveNode();
						return self.performAction(
							self.prepareAction(baseActionKey, nodeID)
						).then(function(context){
							self.refreshTrees();
							return context;
						});
					}
				}

				return utils.promise.reject();
			});
		}
	},

	hooks: {
		async onDecision($element, options){
			switch(options.decisionType){
				case 'submit':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							var modalContentComponent = options.decisionComponent.actions.loadContent.source.load.component;
							if(modalContentComponent && modalContentComponent.hasClass('templates_propertiesForms_mailingListPropertiesForm')){
								await modalContentComponent.submit()
								await options.decisionComponent.hide()
							}
							break;
					}
					break;

				case 'cancel':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							options.decisionComponent.hide()
							break;
					}
					break;

				default:
					// TODO: ERROR;
					break;
			}
		}
	},

	handlers: [
		{
			name: 'afterCancel',
			componentClass: 'templates_propertiesForms_mailingListPropertiesForm',
			handle: function(callerComponent){
				this.deselectActiveNode();
			}
		},
		{
			name: 'onSubmitDone',
			componentClass: 'templates_propertiesForms_mailingListPropertiesForm',
			handle: function(callerComponent, nodeData, insertPerformed){
				if(insertPerformed){
					this.config.readyNodeID       = nodeData.data.attributes[nodeData.data.primaryKey] ;
					this.config.readyNodeContext  = 'mailinglist';
				}
				this.refreshTrees();
			}
		}
	]
};
